// extracted by mini-css-extract-plugin
export default {"batchItem":"batchCancel_batchItem__IR9Uv","priId":"batchCancel_priId__fXJAi","input":"batchCancel_input__hX3Ji"};